import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityUsageSlice } from './get';

export const coreDataSecurityUsageReducers = combineReducers({
	get: getCoreDataSecurityUsageSlice.asyncReducers
});

export const coreDataSecurityUsageWatchers = combineAllWatchers([ getCoreDataSecurityUsageSlice.asyncWatchers ]);
